import React from 'react';
import styled from 'styled-components';

import ICONS from 'components/Icons';

const ApiErrorImage = styled.img`
  width: 5.5em;
  margin-top: 6px;
`;

export const ApiError = () => (
  <ApiErrorImage
    src={ICONS.ERROR.LANDLORD.API_ERROR}
    tabIndex={-1}
    alt="Building for rent graphic"
  />
);

export default ApiError;
